'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function styleInject(css, id) {
  let {
    insertAt
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!css) return;
  if (typeof document === 'undefined') {
    globalThis.ssrCss = globalThis.ssrCss || [];
    globalThis.ssrCss.push({
      css,
      id
    });
    return;
  }
  if (document.getElementById(id)) return;
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.id = id;
  if (insertAt === 'top' && head.firstChild) {
    head.insertBefore(style, head.firstChild);
  } else {
    head.appendChild(style);
  }
  style.appendChild(document.createTextNode(css));
}

exports["default"] = styleInject;
